<template>
  <div id="top-categories-section" class="padding-2xl-top">
    <h2
      v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
      class="title animate--delay-100 hide">
      Top Categories
    </h2>
    <div class="categories z-level-1 relative">
      <div id="half-categories" class="absolute l:visible bg-lead"></div>
      <div
        class="animate--delay-1000 z-level-1 container container-m flex-center flex-wrap gap-xl padding-2xl-bottom">
        <div
          v-for="(category, index) of categories"
          :key="category.id"
          v-intersect="{ animate: 'fadeInDown', removeClass: 'hide' }"
          class="hide"
          :class="`animate--delay-${index * 100 + 400}`">
          <saffron-link
            :to="
              isLoggedIn
                ? { name: 'store-categories-cid-deals', params: { cid: category.id } }
                : { name: 'user-register' }
            "
            class="category-card plain-link flex-column flex-center flex-middle c-text text-center gap-m">
            <img class="icon-image" :src="category.categoryIcon" />
            <span class="text-l">{{ category.name }}</span>
          </saffron-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";

export default {
  name: "TopCategories",
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);

    return {
      asyncOps,
      asyncOpsReady,
      asyncStatus,
    };
  },
  data() {
    return {
      categories: [],
      asyncData: {
        categories: {
          target: "justopp/categories",
          data: {
            ordering: { key: "order", direction: "asc" },
            pagination: { start: 0, limit: 6 },
            filters: {
              type: "products",
              featured: true,
              level: 1, // "first" level categories
              //  anyChildOf: 14, // only product categories
            },
            with: ["productCount"],
          },
          options: {
            dataMutator: (data) => {
              return data.items ? data.items : [];
            },
          },
        },
      },
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["user/isLoggedIn"];
    },
  },
  methods: {
    nameToSvg(name) {
      return name.replace(/\s+/g, "-").toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
}

.category-card {
  height: 145px;
  width: 145px;
  border-radius: var(--border-radius-sharp);
  border-color: var(--c-gray-2-alt);
  border-width: 3px;
  background-color: var(--c-bg);
  transition: transform, box-shadow 200ms ease;

  &:hover {
    transform: scale(1.05, 1.05);
    box-shadow: var(--box-shadow-3);
    z-index: var(--z-level-2);
    border: 1px solid var(--c-gray-3);
  }
}

#top-categories-section {
  background-color: var(--c-light-gray-2);

  @media (min-width: 1024px) {
    background-color: var(--c-lead);
  }
}

#half-categories {
  height: 50%;
  width: 100%;
  top: 0;
  z-index: -1;
}

.categories {
  width: 100%;
  background-color: var(--c-light-gray-2);
}

.hide {
  opacity: 0;
}

.icon-image {
  max-width: 50%;
  aspect-ratio: 1.5;
}
</style>
